import React, { useCallback } from 'react';
import propTypes from 'prop-types';
import { NavLink, Link } from 'react-router-dom';
import { UiTable } from 'src/ui';
import { Button, MuiDropdown, MuiDropdownItem } from 'src/ui/mui-ui-kit';;
;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function UsersTable({
  loading,
  users,
  paging,
  onDeleteUser,
  onSendInvite,
}) {
  const onDelete = useCallback(user => () => onDeleteUser(user), []);

  /* eslint-disable react/prop-types */
  const tableColumns = [
    {
      Header: 'Name',
      accessor: 'name',
      Cell: ({ value, original }) => (
        <div className="member-name">
          <div>
            <Link className="edit-link" to={`/users/edit/${original.id}`}>
              {value}
            </Link>
          </div>
          <small className="has-text-grey-medium-dark">
            {original.title && `${original.title} | `}
            {original.emailAddress}
          </small>
        </div>
      ),
    },
    {
      Header: 'Role',
      accessor: 'roleName',
      Cell: ({ value }) => (
        <div className="has-text-centered has-text-grey-medium-dark">
          {value}
        </div>
      ),
    },
    {
      Header: '',
      accessor: 'id',
      sortable: false,
      width: 62,
      resizable: false,
      Cell: row => (
        <MuiDropdown
          isAlign="right"
          renderTrigger={
            <Button isColor="white">
              <span className="icon">
                <FontAwesomeIcon
                  icon={['fal', 'ellipsis-v']}
                  className="has-text-grey"
                  size="lg"
                />
              </span>
            </Button>
          }
        >
            <MuiDropdownItem tag={NavLink} to={`/users/edit/${row.value}`}>
              Edit
            </MuiDropdownItem>
            <MuiDropdownItem tag="a" onClick={onDelete(row.original)}>
              Archive
            </MuiDropdownItem>
            <MuiDropdownItem tag="a" onClick={() => onSendInvite(row.original)}>
              Send Invite
            </MuiDropdownItem>
        </MuiDropdown>
      ),
    },
  ];
  /* eslint-enable */

  return (
    <UiTable
      columns={tableColumns}
      loading={loading}
      data={users}
      title="User"
      emptyTo="/users/add"
      paging={paging}
      hideNext
      hidePrev
    />
  );
}

UsersTable.propTypes = {
  loading: propTypes.bool.isRequired,
  users: propTypes.arrayOf(propTypes.object).isRequired,
  paging: propTypes.object.isRequired,
  onDeleteUser: propTypes.func.isRequired,
  onSendInvite: propTypes.func.isRequired,
};
